<script>
  import TrendChart from './TrendChart.vue';

  export default {
    name: 'VialsPerMonth',
    extends: TrendChart,
    data() {
      return {
        chartId: 'vialsPerMonth',
        fields: [
          'scit_vials_total',
          'slit_vials_total',
        ],
      };
    },
  };
</script>
